import { ThemeOptions } from "@mui/material/styles"

import { colors } from "@constants/colors-deprecated"

import { ThemeProps } from "./types"

export const typography = ({
  darkMode,
}: ThemeProps): ThemeOptions["typography"] => {
  return {
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
    h1: {
      letterSpacing: 0,
      fontSize: "2rem", // 32px
      lineHeight: "2.25rem", // 36px,
      fontWeight: 500,
    },
    h2: {
      letterSpacing: 0,
      fontSize: "1.75rem", // 28px
      lineHeight: "2rem", // 32px
      fontWeight: 500,
    },
    h3: {
      letterSpacing: 0,
      fontSize: "1.5rem", // 24px
      lineHeight: "1.75rem", // 28px
      fontWeight: 500,
    },
    h4: {
      letterSpacing: 0,
      fontSize: "1.25rem", // 20px
      lineHeight: "1.5rem", // 24px
      fontWeight: 500,
    },
    h5: {
      letterSpacing: 0,
      fontSize: "1rem", // 16px
      lineHeight: "1.25rem", // 20px
      fontWeight: 500,
    },
    h6: {
      letterSpacing: 0,
      fontSize: "0.8125rem", // 13px
      lineHeight: "1.25rem", // 20px
      fontWeight: 600,
    },
    subtitle1: {
      // Default
      fontSize: "0.8125rem", // 13px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: "1rem", // 16px, to align with icons
    },
    subtitle2: {
      // Emphasis
      fontSize: "0.8125rem", // 13px
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: "1rem", // 16px, to align with icons
    },
    body1: {
      // Default
      fontSize: "0.8125rem", // 13px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: "1.25rem", // 20px
    },
    body1Link: {
      // Same as body1
      fontSize: "0.8125rem", // 13px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: "1.25rem", // 20px
      // Underline specific
      textDecoration: "underline",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textDecorationColor: darkMode
        ? colors.STANDARD_WHITE
        : colors.BORDER_GRAY,
      textDecorationThickness: "auto",
      textUnderlineOffset: "0.25rem",
      textUnderlinePosition: "from-font",
    },
    body2: {
      // Emphasis
      fontSize: "0.8125rem", // 13px
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: "1.25rem", // 20px
    },
    body2Link: {
      fontSize: "0.8125rem", // 13px
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: "1.25rem", // 20px
      textDecorationLine: "underline",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textDecorationThickness: "auto",
      textUnderlineOffset: "0.25rem",
      textUnderlinePosition: "from-font",
    },
    button: {
      // Default
      fontSize: "0.8125rem", // 13px
      lineHeight: "1rem", // 16px, to align with 16x16 icons
      fontWeight: 500,
      textTransform: "none", // Regular capitalization
    },
    buttonSm: {
      // Small
      fontSize: "0.6875rem", // 11px
      lineHeight: "0.75rem", // 12px, to align with 12x12 icons
      fontWeight: 500,
      textTransform: "none", // Regular capitalization
    },
    caption: {
      // Default
      letterSpacing: 0,
      fontSize: "0.75rem", // 12px
      lineHeight: "1rem", // 16px
      fontWeight: 400,
    },
    caption2: {
      // Emphasis
      letterSpacing: 0,
      fontSize: "0.75rem", // 12px
      lineHeight: "1rem", // 16px
      fontWeight: 600,
    },
    overline: {
      // Default, matches overline1 in Figma
      fontSize: "0.6875rem", // 11px
      letterSpacing: 0,
      lineHeight: "1rem", // 16px
      textTransform: "none",
    },
    overline2: {
      // Emphasis
      fontSize: "0.6875rem", // 11px
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: "1rem", // 16px
    },
  }
}
